/// <reference path="../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass() 
    export class AdditionalChargesSelectGrid extends _Ext.GridBase<OMS.AdditionalChargesRow, any> {
        protected getColumnsKey() { return 'OMS.AdditionalCharges'; }
        protected getIdProperty() { return OMS.AdditionalChargesRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.AdditionalChargesRow.localTextPrefix; }
        protected getService() { return OMS.AdditionalChargesVouchersService.baseUrl; }
        protected useViewMode() { return true; }
        items: any[];

        constructor(container: JQuery, options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });
            var vouchertypeid = options.GridFilters.VoucherTypeId;
            var applicableon = options.GridFilters.ApplicableOn;
            (this.view.params as TransactionRequest).VoucherTypeId = vouchertypeid;
            (this.view.params as TransactionRequest).ApplicableOn = applicableon;


        }
        private autoSize;


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
     
}